import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from "@ngrx/store";
import { CirculationId, Step } from "src/app/interfaces";
import * as AppState from "./../../state/app.state";
import * as fromStep from "./step.reducer";

export interface State extends AppState.State {
  circulation: fromStep.StepState;
}

const mapStepToStepClass = (s: Step): Step => {
  if (!s) {
    return null;
  }
  return new Step(s.props, s.id);
};

// Selector functions
const selectStepState = createFeatureSelector<fromStep.StepState>("steps");

export const selectStepEntities = createSelector(
  selectStepState,
  fromStep.selectStepEntities
);

export const selectStep = (
  id: string | number
): MemoizedSelector<State, Step> =>
  createSelector(selectStepEntities, (steps) => mapStepToStepClass(steps[id]));

export const selectCurrentStep = createSelector(
  selectStepEntities,
  AppState.selectStepId,
  (state, stepId) => state[stepId]
);

export const selectAllSteps = createSelector(
  selectStepState,
  fromStep.selectAllSteps
);

export const selectStepLoaded = createSelector(selectStepState, () => true);

export const selectStepIsLoading = createSelector(selectStepState, () => false);

export const selectStepsOfCirculation = (
  id: CirculationId
): MemoizedSelector<State, Step[]> =>
  createSelector(selectAllSteps, (steps: Step[]) =>
    steps
      .filter((step) => {
        return step.props.circulationId == id;
      })
      .map((s) => mapStepToStepClass(s))
  );

export const selectCirculationError = createSelector(
  selectStepState,
  (state) => state.error
);
